import React, { useCallback } from "react";
import * as Scrivito from "scrivito";
import { Pagination, PaginationItem, PaginationLink } from "reactstrap";
import cx from "classnames";
import { Icon } from "../../Icon/Icon";

type Props = {
  pagesAround?: number;
  pagesNumbersArr: number[];
  currentPageIdx: number;
  onChangePage: (idx: number) => void;
};

export const ZonesPagination = Scrivito.connect(
  ({
    pagesAround = 4,
    pagesNumbersArr,
    currentPageIdx,
    onChangePage,
  }: Props) => {
    const startIdx = useCallback(
      (pageIdx: number): number => {
        if (
          pageIdx > pagesAround + 1 &&
          pageIdx < pagesNumbersArr.length - pagesAround - 1
        ) {
          return pageIdx - pagesAround - 1;
        } else if (pageIdx <= pagesAround + 1) {
          return 0;
        } else {
          return pagesNumbersArr.length - pagesAround * 2 - 2;
        }
      },
      [pagesAround, pagesNumbersArr.length],
    );

    const endIdx = useCallback(
      (pageIdx: number): number => {
        if (pageIdx > pagesAround) {
          return pageIdx + pagesAround + 2;
        }
        if (pageIdx <= pagesAround * 2 + 2) {
          return pagesAround * 2 + 3;
        }
        return pagesNumbersArr.length - 1;
      },
      [pagesAround, pagesNumbersArr.length],
    );

    const handlePageChange = (pageIdx: number): void => {
      onChangePage(pageIdx);
    };

    return (
      <Pagination aria-label="Zones navigation">
        <PaginationItem
          disabled={currentPageIdx === 1 || pagesNumbersArr.length <= 2}
        >
          <PaginationLink onClick={() => handlePageChange(currentPageIdx - 1)}>
            <Icon iconName="chevron-left-regular" />
          </PaginationLink>
        </PaginationItem>

        {pagesNumbersArr.map(
          (pageNum, idx) =>
            idx > 0 && (
              <PaginationItem
                key={idx}
                active={pageNum === pagesNumbersArr[currentPageIdx]}
                className={cx({
                  "d-none":
                    idx <= startIdx(currentPageIdx) ||
                    idx >= endIdx(currentPageIdx),
                })}
              >
                <PaginationLink onClick={() => handlePageChange(idx)}>
                  {pageNum}
                </PaginationLink>
              </PaginationItem>
            ),
        )}

        <PaginationItem
          disabled={
            currentPageIdx === pagesNumbersArr.length - 1 ||
            pagesNumbersArr.length <= 2
          }
        >
          <PaginationLink onClick={() => handlePageChange(currentPageIdx + 1)}>
            <Icon iconName="chevron-right-regular" />
          </PaginationLink>
        </PaginationItem>
      </Pagination>
    );
  },
);
